/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-04-10 18:43:40
 * @Description: 消防检测项目管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const xmglService = {

  // 获取检测项目列表
  query: (params) => { return axios.get(`${iffApi}/xfjc/jcxm`, { params: params }); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfjc/jcxm/export`, { responseType: 'blob', params }); },

  // 作废
  delete: (id) => { return axios.delete(`${iffApi}/xfjc/jcxm/${id}`); },

  // 获取详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfjc/jcxm`, fd); },

  // 更新
  update: (fd) => { return axios.put(`${iffApi}/xfjc/jcxm`, fd); },

  // 生成报告
  scbg: (xmId) => { return axios.get(`${iffApi}/xfjc/jcxm/${xmId}/scbg`); },

  // 生成临时报告
  sclsbg: (xmId) => { return axios.get(`${iffApi}/xfjc/jcxm/${xmId}/sclsbg`); },

  // 获取项目状态
  getStatus: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/status`); },

  // 签章
  qz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/qz`); },

  // 盖章
  gz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/gz`); },

  // 重新检测
  cxjc: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/cxjc`); },

  // 加盖公章
  jggz: (id) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/jggz`); },

  // 获取检测结论说明
  getJcjl: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/jcjl`); },

  // 获取系统检测内容列表
  getXtJcnrList: () => { return axios.get(`${iffApi}/xfjc/jcxm/jcnrAll`); },

  // 保存检测结论说明
  saveJcjl: (params) => { return axios.post(`${iffApi}/xfjc/jcxm/jcjl`, params); },

  // 获取检测项状态
  getJcxStatus: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/jcx/status`); },

  sqxg: (id, fd) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/sqxg`, fd); },

  // 获取可转移用户列表
  getTranslateUsers: (xmId) => { return axios.get(`${iffApi}/xfjc/jcxm/xmusers/${xmId}`); },

  // 项目转移
  translate: (fd) => { return axios.post(`${iffApi}/xfjc/jcxm/translate`, fd); }

};
